function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icons/Pagination/Previous");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icons/Pagination/Previous",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.1096875,16.7853125 C13.5159375,16.7853125 13.820625,16.480625 13.820625,16.074375 C13.820625,15.8790625 13.7425,15.699375 13.6175,15.5665625 L7.93,10.0040625 L13.6175,4.4415625 C13.7425,4.30875 13.820625,4.12125 13.820625,3.93375 C13.820625,3.5275 13.5159375,3.215 13.1096875,3.215 C12.9065625,3.215 12.7346875,3.293125 12.601875,3.4259375 L6.414375,9.480625 C6.2659375,9.605625 6.18,9.8009375 6.18,10.0040625 C6.18,10.199375 6.258125,10.3790625 6.4065625,10.5275 L12.601875,16.574375 C12.7346875,16.7071875 12.9065625,16.7853125 13.1096875,16.7853125 Z",
  id: "ic-previous",
  fill: "#70707D",
  fillRule: "nonzero",
  transform: "translate(10.000313, 10.000156) scale(-1, 1) rotate(-180.000000) translate(-10.000313, -10.000156) "
}));

var SvgPrevious = function SvgPrevious(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrevious, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/previous.92ec09f5.svg";
export { ForwardRef as ReactComponent };